// App wide container width. Ensures the same container width is used across the entire app.
export const APP_CONTAINER_MAX_WIDTH_DESKTOP = "lg";
export const APP_CONTAINER_MAX_WIDTH_MOBILE = false;
// Container padding is not used for all containers. It is only used for the main content container.
export const APP_CONTAINER_PADDING_DESKTOP = { pt: 4, pb: 3 };
export const APP_CONTAINER_PADDING_MOBILE = { pt: 2, pb: 2 };
